import React from 'react';

// 25/09 (Marlon) : trois rythmes de paiement. Le trimestriel (-10 %) sert autant au
// client qu'à nous : un prélèvement au lieu de trois, donc trois fois moins de cartes
// qui échouent. Il reste moins avantageux que l'annuel, exprès.
const RYTHMES = [
  { key: 'month', label: 'Mensuel', remise: null },
  { key: 'quarter', label: '3 mois', remise: '-10%' },
  { key: 'year', label: 'Annuel', remise: '-20%' },
];

export default function IntervalToggle({ interval, setInterval }) {
  return (
    <div className="flex justify-center mb-6" data-testid="plan-picker">
      <div className="inline-flex rounded-xl bg-white/5 border border-white/10 p-1" data-testid="billing-toggle">
        {RYTHMES.map((r) => (
          <button
            key={r.key}
            type="button"
            onClick={() => setInterval(r.key)}
            data-testid={`billing-${r.key}`}
            className={`px-4 py-1.5 text-sm font-medium rounded-lg transition-colors flex items-center gap-1.5 ${
              interval === r.key ? 'bg-indigo-500 text-white' : 'text-slate-400 hover:text-white'}`}
          >
            {r.label}
            {r.remise && (
              <span className="px-1.5 py-0.5 rounded text-[9px] font-bold bg-emerald-500/20 text-emerald-300">{r.remise}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
